import React from 'react';
import styled from 'styled-components';
import loupe_grise from '../../assets/loupe_grise.png';
import loupe_blanche from '../../assets/loupe.png';

// Styles copied from SelectFormation.js
const SearchInputContainer = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 25px;
  border: ${props => props.active ? '1px solid #38B6FF' : '1px solid #E6E6E6'};
  background: #FFF;
  overflow: hidden;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 20px;
  border: none;
  font-size: 15px;
  font-family: 'Gabarito', sans-serif;
  font-weight: 400;
  line-height: 108.52%;
  text-align: left;
  outline: none;
  background: transparent;

  &::placeholder {
    color: #C4C4C4;
    text-align: left;
    font-family: Gabarito;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 108.52%;
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchIconCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  margin-right: -3px;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.active ? '#38B6FF' : '#E6E6E6'};
`;

const SearchInputComponent = ({ value, onChange, onFocus, placeholder, inputRef }) => {
  const isActive = value.length > 0;

  return (
    <SearchInputContainer ref={inputRef} active={isActive}>
      <SearchInput
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
      />
      <SearchIcon>
        <SearchIconCircle active={isActive}>
          {isActive ? (
            <img src={loupe_blanche} alt="Search Active" style={{ width: '20px', height: '20px' }} />
          ) : (
            <img src={loupe_grise} alt="Search Inactive" style={{ width: '20px', height: '20px' }} />
          )}
        </SearchIconCircle>
      </SearchIcon>
    </SearchInputContainer>
  );
};

export default SearchInputComponent; 